module.exports = __webpack_public_path__ + "static/media/inventory-icon.ca31ac0a.svg";